import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_how_many_complaints_grievances_were_received_male'

export const dataPointDefinition = {
  retracedId: 'yes_how_many_complaints_grievances_were_received_male',
  name: 'If yes, how many complaints and grievances were received by male workers?',
  description:
    'If the facility does not keep track of gender, e.g., confidentiality of process means identity of worker is unknown, then enter 0 and attach a document explaining your process. ',
  meta: {
    slcpMeta: {
      key: 'wi-gri-10',
      number: 'WI-GRI-13',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],gr-6,Yes;Yes- but records are incomplete',
      machineShowHide: '[2],gr-6,1;2',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-10', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36610,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
